import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "leontech_cart_v1";

const readCart = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(readCart);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (line) => {
      setItems((prev) => {
        const ex = prev.find((i) => i.key === line.key);
        if (ex) return prev.map((i) => (i.key === line.key ? { ...i, qty: i.qty + line.qty } : i));
        return [...prev, line];
      });
      setOpen(true);
    };
    const setQty = (key, qty) =>
      setItems((prev) => (qty <= 0 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, qty } : i))));
    const count = items.reduce((s, i) => s + i.qty, 0);
    const subtotal = items.reduce((s, i) => s + i.unit_price * i.qty, 0);
    return { items, add, setQty, remove: (k) => setQty(k, 0), clear: () => setItems([]), count, subtotal, open, setOpen };
  }, [items, open]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
